// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield40: FC<CheckShield40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m18.195 25.667 9.472-9.473-1.959-1.93-7.43 7.43-3.972-3.972-2.014 2.014 5.903 5.93ZM20 36.639c-3.88-.972-7.072-3.215-9.576-6.73-2.505-3.513-3.757-7.381-3.757-11.604v-10l13.333-5 13.333 5v10c0 4.223-1.252 8.09-3.757 11.605-2.504 3.514-5.696 5.757-9.576 6.729Zm0-2.889c3.093-1.01 5.625-2.95 7.597-5.82 1.973-2.87 2.959-6.078 2.959-9.625v-8.069L20 6.264 9.444 10.236v8.07c0 3.546.986 6.754 2.959 9.625 1.972 2.87 4.504 4.81 7.597 5.819Z" />
        </svg>
    );
};

export default CheckShield40;
